/* globals Tesseract */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import firebase from 'firebase/app';

import Alert from 'components/Alert';

import 'styles/CameraCard.scss';

class CameraCard extends Component {
  static propTypes = {
    cameraId: PropTypes.string.isRequired,
  };

  state = {
    camera: {},
    cameraRef: null,
    windowWidth: window.innerWidth,
    cameraOutOfOrder: false,
    initalCameraImageProcessing: true,
  };

  db = firebase.database();

  onWindowResize = () => {
    this.setState((state) => {
      return {
        ...state,
        windowWidth: window.innerWidth,
      };
    });
  };

  cameraRefValueCallback = (snapshot) => {
    this.setState((state) => {
      return {
        ...state,
        camera: snapshot.val(),
      };
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.cameraId !== this.props.cameraId) {
      this.state.cameraRef.off('value', this.cameraRefValueCallback);

      const cameraRef = this.db.ref(`gbgcamera/${nextProps.cameraId}`);

      this.setState((state) => {
        return {
          ...state,
          cameraRef,
        };
      });

      cameraRef.on('value', this.cameraRefValueCallback);
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.onWindowResize, false);

    const cameraRef = this.db.ref(`gbgcamera/${this.props.cameraId}`);

    this.setState((state) => {
      return {
        ...state,
        cameraRef,
      };
    });

    cameraRef.on('value', this.cameraRefValueCallback);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      camera: {
        image: cameraImage = null,
      } = {},
      windowWidth,
    } = this.state;

    const {
      camera: {
        image: oldCameraImage = null,
      } = {},
    } = prevState;

    if (oldCameraImage === cameraImage) {
      return;
    }

    if (windowWidth < 1000 || !cameraImage) {
      return;
    }

    Tesseract.recognize(cameraImage, {
      lang: 'swe',
    }).then((result) => {
      this.setState((state) => {
        return {
          ...state,
          cameraOutOfOrder: result.text.trim() === 'Tillfälligt ur funktion!',
          initalCameraImageProcessing: false,
        };
      });
    }).catch((error) => {
      console.error(error);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  render() {
    const {
      camera: {
        image: cameraImage = null,
      } = {},
      windowWidth,
      cameraOutOfOrder,
      initalCameraImageProcessing,
    } = this.state;

    if (windowWidth < 1000) {
      return null;
    }

    if (!cameraImage || initalCameraImageProcessing) {
      return (
        <div className='Card CameraCard animated fadeIn'>
          <div className='Card__body'>
            <div className='Card__spinner'>
              <div className='Spinner Spinner--camera' />
            </div>
          </div>
        </div>
      );
    }

    if (cameraOutOfOrder) {
      return (
        <div className='Card animated fadeIn'>
          <Alert
            type='info'
            icon='linked_camera'
            title='Tillfälligt ur funktion'
          >
            <span>
              Kameran från Göteborgs Stad som normalt syns här är tillfälligt ur funktion.
            </span>
          </Alert>
        </div>
      );
    }

    return (
      <div className='MediaCard CameraCard animated fadeIn'>
        <img
          alt=''
          src={cameraImage}
          className='MediaCard__media'
          draggable='false'
        />
      </div>
    );
  }
}

export default CameraCard;



// WEBPACK FOOTER //
// ./src/components/CameraCard.jsx